module.exports = __webpack_public_path__ + "img/active-3.32a1fc6e.png";